import defaultConfig from "./configuration.json";

interface configuration {
  logo: string;
}

const config: configuration = defaultConfig;

export default config;
